const Bone = ({ className }) => (
  <div className={`animate-pulse rounded-lg bg-muted ${className || ""}`} />
);

export const PageSkeleton = ({ stats = 4, rows = 5, chart = false }) => (
  <div className="space-y-4" data-testid="page-skeleton" aria-busy="true" aria-label="Memuat data">
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2.5">
      <div className="space-y-2">
        <Bone className="h-6 w-44" />
        <Bone className="h-3.5 w-64" />
      </div>
      <Bone className="h-8 w-40" />
    </div>
    {stats > 0 && (
      <div className={`grid grid-cols-2 gap-3 ${stats >= 4 ? "lg:grid-cols-4" : stats === 3 ? "lg:grid-cols-3" : "lg:grid-cols-2"}`}>
        {Array.from({ length: stats }).map((_, i) => (
          <div key={i} className="rounded-xl border border-border bg-card p-4 flex items-center gap-2.5">
            <Bone className="h-9 w-9 rounded-lg shrink-0" />
            <div className="space-y-1.5 flex-1 min-w-0">
              <Bone className="h-2.5 w-2/3" />
              <Bone className="h-4 w-1/2" />
            </div>
          </div>
        ))}
      </div>
    )}
    {chart && (
      <div className="rounded-xl border border-border bg-card p-4">
        <Bone className="h-4 w-40 mb-3" />
        <Bone className="h-44 w-full" />
      </div>
    )}
    {rows > 0 && (
      <div className="rounded-xl border border-border bg-card overflow-hidden">
        <div className="border-b-2 border-border bg-muted/40 p-3 flex gap-3">
          <Bone className="h-3 w-24" /><Bone className="h-3 w-32" /><Bone className="h-3 w-20 ml-auto" />
        </div>
        <div className="divide-y divide-border">
          {Array.from({ length: rows }).map((_, i) => (
            <div key={i} className="p-3 flex items-center gap-3">
              <Bone className="h-3.5 w-20" />
              <Bone className="h-3.5 w-28" />
              <Bone className="h-3.5 w-16 hidden sm:block" />
              <Bone className="h-3.5 w-24 ml-auto" />
              <Bone className="h-6 w-14 rounded-md" />
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);
